import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/Layout";
import { TextField, SelectField } from "../components/Field";
import { Button } from "../components/ui/button";
import { Switch } from "../components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const ROLES = [{ value: "staff", label: "Staff" }, { value: "admin", label: "Amministratore" }];

export default function Utenti() {
  const { user: me } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "staff" });
  const load = () => api.get("/users").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/users", f); toast.success("Utente creato"); setOpen(false); setF({ name: "", email: "", password: "", role: "staff" }); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const update = async (u, data) => {
    try { await api.put(`/users/${u.id}`, data); toast.success("Utente aggiornato"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const resetPwd = (u) => {
    const p = window.prompt(`Nuova password per ${u.email} (min 6 caratteri)`);
    if (p) update(u, { password: p });
  };
  const remove = async (u) => {
    if (!window.confirm(`Eliminare l'utente ${u.email}?`)) return;
    try { await api.delete(`/users/${u.id}`); toast.success("Utente eliminato"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader title="Utenti" subtitle="Account dello staff con accesso all'app">
        <Button onClick={() => setOpen(true)} className="bg-[#B08D57] hover:bg-[#96764A]" data-testid="new-user-btn"><Plus className="mr-1 h-4 w-4" /> Nuovo utente</Button>
      </PageHeader>
      <div className="overflow-x-auto rounded-md border bg-white">
        <Table>
          <TableHeader><TableRow><TableHead>Nome</TableHead><TableHead>Email</TableHead><TableHead>Ruolo</TableHead><TableHead>Attivo</TableHead><TableHead className="w-24" /></TableRow></TableHeader>
          <TableBody>
            {items.map((u) => {
              const self = u.id === me.id;
              return (
                <TableRow key={u.id} data-testid={`user-row-${u.id}`}>
                  <TableCell className="font-semibold">{u.name}{self && <span className="ml-2 text-xs text-muted-foreground">(tu)</span>}</TableCell>
                  <TableCell className="text-sm">{u.email}</TableCell>
                  <TableCell className="w-44">
                    {self ? <span className="text-sm">Amministratore</span> :
                      <SelectField label="" value={u.role} onChange={(role) => update(u, { role })} options={ROLES} testId={`user-role-${u.id}`} />}
                  </TableCell>
                  <TableCell><Switch checked={u.active} disabled={self} onCheckedChange={(active) => update(u, { active })} data-testid={`user-active-${u.id}`} /></TableCell>
                  <TableCell className="whitespace-nowrap text-right">
                    <Button size="icon" variant="ghost" onClick={() => resetPwd(u)} data-testid={`user-reset-pwd-${u.id}`}><KeyRound className="h-4 w-4" /></Button>
                    {!self && <Button size="icon" variant="ghost" onClick={() => remove(u)} data-testid={`delete-user-${u.id}`}><Trash2 className="h-4 w-4 text-red-600" /></Button>}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="user-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl">Nuovo utente</DialogTitle></DialogHeader>
          <div className="grid gap-4">
            <TextField label="Nome" value={f.name} onChange={(name) => setF({ ...f, name })} testId="user-name-input" />
            <TextField label="Email" type="email" value={f.email} onChange={(email) => setF({ ...f, email })} testId="user-email-input" />
            <TextField label="Password (min 6)" type="password" value={f.password} onChange={(password) => setF({ ...f, password })} testId="user-password-input" />
            <SelectField label="Ruolo" value={f.role} onChange={(role) => setF({ ...f, role })} options={ROLES} testId="user-role-select" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="user-cancel-btn">Annulla</Button>
            <Button onClick={create} disabled={!f.name || !f.email || f.password.length < 6} className="bg-[#B08D57] hover:bg-[#96764A]" data-testid="user-save-btn">Crea utente</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
